import Config from "../config/config";
import axios from "axios";
import * as CryptoJs from "crypto-js";

export const getCookie = (cookieName) => {
  let name = cookieName + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const isEmpty = (value) =>
  value === undefined ||
  value == "undefined" ||
  value === null ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim().length === 0) ||
  (typeof value === "string" && value === "0") ||
  (typeof value === "number" && value === 0);

export const NumberChange = (data) => {
  try {
    return isNaN(Number(data)) ? 0 : Number(data);
  } catch (err) {
    console.log("NumberChange_error", err);
    return 0;
  }
};

export const NumberOnly = (data) => {
  return data.toString().replace(Config.NumOnly, "");
};

export const GetToken = (key) => {
  if (key) {
    let cookie = ("; " + document.cookie)
      .split(`; ${key}=`)
      .pop()
      .split(";")[0];
    return cookie;
  } else {
    return undefined;
  }
};

export const SetToken = (tokenkey, token) => {
  if (tokenkey && token) {
    document.cookie = `${tokenkey}= ${token}`;
  }
  return true;
};

export const deleteToken = (tokenkey) => {
  if (tokenkey) {
    document.cookie = `${tokenkey}= ; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
  return undefined;
};

export const axiosFunc = async (data, token) => {
  try {
    let Resp = {};
    // if(false){
    if (data?.params) {
      data.params = { data: EncryptData(data.params) };
    } else if (data?.data) {
      if (!(data?.data instanceof FormData)) {
        data.data = { data: EncryptData(data.data) };
      }
    }
    if (data?.headers) {
      data.headers.Authorization =
        "Bearer " + (token ?? GetToken(Config.userCookieName));
    } else {
      data.headers = {
        Authorization: "Bearer " + (token ?? GetToken(Config.userCookieName)),
      };
    }
    // }
    Resp = await axios(data);
    if (Resp?.data) {
      Resp.data =
        typeof DecryptData(Resp.data) == "string" &&
        DecryptData(Resp.data) == ""
          ? Resp.data
          : DecryptData(Resp.data);
    }
    if (data?.url?.includes("/getUserCollection")) {
      console.log("mdshfshfsfsfafa", Resp, DecryptData(Resp.data));
    }

    return Resp;
  } catch (e) {
    return { success: "error", msg: null };
  }
};

const AppenData = (data) => {
  var formdata = new FormData();
  var SendDta = Object.entries(data).map((item) => {
    if (Array.isArray(item[1])) {
      var come = item[1].map((data) => {
        if (data?.type && data?.size) {
          //file
          formdata.append(item[0], data);
        } else {
          formdata.append(item[0], EncryptData(data));
        }
        return formdata;
      });
      return come;
    } else {
      if (item[1]?.type && item[1]?.size) {
        //file type
        formdata.append(item[0], item[1]);
      } else {
        formdata.append(item[0], EncryptData(item[1]));
      }
      return formdata;
    }
  });
  console.log("dkshfsfsfkjshf", SendDta, formdata);
  return [formdata];
};

export const EncryptData = (data) => {
  if (typeof data == "string") {
    return CryptoJs.AES.encrypt(data, Config.KEY).toString();
  } else {
    return CryptoJs.AES.encrypt(JSON.stringify(data), Config.KEY).toString();
  }
};

export const DecryptData = (data) => {
  try {
    var bytes = CryptoJs.AES.decrypt(data, Config.KEY);

    var decryptedData;
    try {
      decryptedData = JSON.parse(bytes.toString(CryptoJs.enc.Utf8));
    } catch (err) {
      try {
        decryptedData = bytes.toString(CryptoJs.enc.Utf8);
      } catch (dcpterr) {
        return "";
      }
    }
    return decryptedData;
  } catch (error) {
    return "";
  }
};

export const formatNumber = (number) => {
  return Number(number).toLocaleString("en-US", {
    // add suffixes for thousands, millions, and billions
    // the maximum number of decimal places to use
    maximumFractionDigits: 2,
    // specify the abbreviations to use for the suffixes
    notation: "compact",
    compactDisplay: "short",
  });
};

export const formatDate = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
